// stores/theme.ts
import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useThemeStore = defineStore('theme', () => {
  const savedTheme = localStorage.getItem('theme');
  const prefersDarkScheme = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const initialTheme = savedTheme ? savedTheme : prefersDarkScheme ? 'dark' : 'light';
  const theme = ref(initialTheme);

  function toggleTheme() {
    theme.value = theme.value === 'light' ? 'dark' : 'light';
    document.documentElement.setAttribute('data-theme', theme.value);
    localStorage.setItem('theme', theme.value);
  }

  function setTheme(newTheme: string) {
    theme.value = newTheme;
    document.documentElement.setAttribute('data-theme', newTheme);
    localStorage.setItem('theme', newTheme);
  }

  // Watch for changes in the system's color scheme
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
    const newColorScheme = e.matches ? 'dark' : 'light';
    setTheme(newColorScheme);
  });

  // Apply the initial theme
  document.documentElement.setAttribute('data-theme', theme.value);

  return { theme, toggleTheme, setTheme };
});
